import { styled, Typography } from '@mui/material';

export const RecommendationWrapperStyled = styled('div')({
  marginTop: '24px',
});

export const RecommendationBannerStyled = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'left',
  marginTop: '40px',
  padding: '24px 40px',
  minHeight: '184px',
  width: '100%',
  backgroundColor: '#F5EDFF',
  borderRadius: '4px 4px 0px 0px',
  border: '1px solid #212935',
  '@media (max-width: 744px)': {
    padding: '24px',
  },
});

export const IconWrapperStyled = styled('div')({
  paddingRight: '16px',
});

export const LightbulbAnimationStyled = styled('img')(({ theme }) => ({
  width: '80px',
  height: '64px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: 'auto',
  },
}));

export const BannerBodyStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const BannerSubTextStyled = styled(Typography)({
  fontSize: '14px',
});

export const InfoDrawerWrapperStyled = styled('div')({
  marginTop: '12px',
  marginBottom: '20px',
  a: {
    fontSize: '14px',
    color: '#000000',
  },
});

export const SurveyDrawerWrapperStyled = styled('div')({
  '.btn-secondary': {
    backgroundColor: 'rgba(0,0,0,0)',
    '&:hover, &:focus': {
      color: '#212529',
    },
  },
});
